import React from 'react';

const SidebarGroup = ({ children, isExpanded = true, isCollapsed = false, level = 1 }) => {
  if (!isExpanded || isCollapsed) return null;

  return (
    <div className={`relative mt-1 space-y-1 transition-all duration-300 ease-in-out ${level === 1 ? 'ml-3.5 pl-3 border-l border-[#EEF2F7]' : 'ml-2.5 pl-2.5 border-l border-[#EEF2F7]'}`}>
      {children}
    </div>
  );
};

export default SidebarGroup;
